import { useContext, useState } from "react";
import { MenuContext } from "../../../../contexts/menu.context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import "./menuSearch.styles.scss";
const MenuSearch = () => {
  const { searchTerm, setSearchTerm } = useContext(MenuContext);

  const handleChange = (event) => {
    const { value } = event.target;
    setSearchTerm(value);
  };

  return (
    <div className="rest-tab-menubox-search">
      <input
        type="text"
        placeholder="Start Typing"
        value={searchTerm}
        className="rest-tab-menubox-input"
        onChange={handleChange}
      />
      <span className="rest-tab-menubox-searchbutton">
        <FontAwesomeIcon icon={faMagnifyingGlass} />
      </span>
    </div>
  );
};
export default MenuSearch;
